import React from 'react'
import { Link } from 'gatsby'
import { Layout, Showcase, SectionTitle, Header } from '../../../../components'

import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <SectionTitle>Variants</SectionTitle>

        <Showcase
          site={data.site}
          title="Input Chip"
          text={
            <p>
              Input chips represent user-entered or selected information. They
              appear inline within a{' '}
              <Link
                class="link"
                to={'/' + data.site + '/components/text-input/develop'}
              >
                text input
              </Link>
              . Input chips use the primary green treatment and do not change
              appearance. They are always dismissible.
            </p>
          }
          code={code.chipBase}
        >
          <div class="c-chip__container u-flex-align--center">
            <div class="c-chip c-chip--active">
              Lorem Ipsum{' '}
              <span class="c-chip__close">
                <i class="icon icon--x" />
              </span>
            </div>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Choice Chip"
          text={
            <p>
              Choice chips allow the user to select one option out of a group of
              many, similar to{' '}
              <Link
                class="link"
                to={'/' + data.site + '/components/radio/develop'}
              >
                radios
              </Link>{' '}
              or{' '}
              <Link
                class="link"
                to={'/' + data.site + '/components/button-group/develop'}
              >
                button groups
              </Link>{' '}
              . Like all inputs, choice chips should always appear with a{' '}
              <Link
                class="link"
                to={'/' + data.site + '/components/label/develop'}
              >
                label
              </Link>
              . Choice chips are initially displayed in the deselected gray
              state. Once selected, the chip will change to its green selected
              state and cannot be deselected unless another chip is selected.
            </p>
          }
          code={code.chipChoice}
        >
          <div class="c-label l-margin-bottom--medium">Choose an option:</div>
          <div class="c-chip__container">
            <div class="c-chip c-chip--active">Option 1</div>
            <div class="c-chip">Option 2</div>
            <div class="c-chip">Option 3</div>
          </div>
        </Showcase>
      </Layout>
    </>
  )
}

export const code = {
  chipInput: `<div class="c-chip__container">
  <div class="c-chip c-chip--active">
    Lorem Ipsum
    <span class="c-chip__close">
      <i class="icon icon--x" />
    </span>
  </div>
</div>`,
  chipChoice: `<label class="c-label l-margin-bottom--medium">
  Choose an option:
</label>
<div class="c-chip__container">
  <div class="c-chip c-chip--active">Option 1</div>
  <div class="c-chip">Option 2</div>
  <div class="c-chip">Option 3</div>
</div>`,
}
